import MainModalContainer from './MainModalContainer';

export default MainModalContainer;
